import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import ApprovalListReducer from './ApprovalListReducer';
import ApprovalDetailReducer from './ApprovalDetailReducer';
import  LocaleReducer from './LocaleReducer';
import  ToastReducer from './ToastReducer';
import  AuthReducer from './AuthReducer';
import ApproveRejectReducer from './ApproveRejectReducer';

export default combineReducers({
    AppReducer,
    ApprovalListReducer,
    ApprovalDetailReducer,
    LocaleReducer,
    ToastReducer,
    AuthReducer,
    ApproveRejectReducer
});
